import _ from "lodash";
import { getRequest, postRequest, patchRequest } from "NetworkCall";
import { INSTANCE_URL, DEVELOPMENT_TYPE } from "Constants";

export var SCHEDULE_SESSION_LIST = "SCHEDULE_SESSION_LIST";
export var SELECTED_SCHEDULE_SESSION_ID = "SELECTED_SCHEDULE_SESSION_ID";
export var ALL_SCHEDULE_SESSION_IDS = "ALL_SCHEDULE_SESSION_IDS";
export var LIVE_QA_LIST = "LIVE_QA_LIST";
export var UNPUBLISHED_LIVE_QA_LIST = "UNPUBLISHED_LIVE_QA_LIST";
export var SELECT_PUBLISHED_TYPE = "SELECT_PUBLISHED_TYPE";
export var LIVE_QA_REPLIES = "LIVE_QA_REPLIES";
export var BROADCAST_QA = "BROADCAST_QA";
export var ALL_PUBLISHED_SESSIONWISE_LIVE_QA_LIST =
  "ALL_PUBLISHED_SESSIONWISE_LIVE_QA_LIST";
export var LIVE_QA_EXPORT_MODAL = "LIVE_QA_EXPORT_MODAL";
export var SCHEDULE_SESSION_RATING = "SCHEDULE_SESSION_RATING";
export var SCHEDULE_SESSION_CHECKOUT_FORM = "SCHEDULE_SESSION_CHECKOUT_FORM";
export var ALL_SCHEDULE_SESSION_RATING = "ALL_SCHEDULE_SESSION_RATING";

export function fetchSchedules(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=scheduleSession&developmenttype=${DEVELOPMENT_TYPE}&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: SCHEDULE_SESSION_LIST, payload: { resource: data } });
        dispatch({
          type: ALL_SCHEDULE_SESSION_IDS,
          payload: {
            resource: data.scheduleSession.map((id) => {
              return Number(id.sessionid);
            }),
          },
        });
        dispatch({
          type: SELECTED_SCHEDULE_SESSION_ID,
          payload: { resource: data.scheduleSession[0].sessionid },
        });
        callback({ success: 1, resource: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchLiveQA(
  session,
  scheduleSessionid,
  pageCount = 0,
  callback
) {
  var perPage = 50;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  // debugger
  var offSetQuery = `limit=${perPage}&offset=${offset}&`;
  var published = `ispublished=1`;
  var orderby = `displayorder%20ASC%2C%20createdon%20DESC`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?related=appuser_by_questionedby&filter=((${published}) AND (eventid=${session.eventid}) AND (sessionid=${scheduleSessionid}))&${offSetQuery}include_count=true&order=${orderby}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: LIVE_QA_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchUnpublishedLiveQA(
  session,
  scheduleSessionid,
  pageCount = 0,
  callback
) {
  var perPage = 50;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${perPage}&offset=${offset}&`;
  var published = `ispublished=0`;
  var orderby = `displayorder%20ASC%2C%20createdon%20DESC`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?related=appuser_by_questionedby&filter=((${published}) AND (eventid=${session.eventid}) AND (sessionid=${scheduleSessionid}))&${offSetQuery}include_count=true&order=${orderby}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: UNPUBLISHED_LIVE_QA_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchSessionWiseLiveQA(session, scheduleSessionid, callback) {
  var published = `ispublished=1`;
  var orderby = `isimportant%20DESC,createdon%20DESC`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?related=appuser_by_questionedby&filter=((${published}) AND (eventid=${session.eventid}) AND (sessionid=${scheduleSessionid}))&include_count=true&order=${orderby}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: ALL_PUBLISHED_SESSIONWISE_LIVE_QA_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function published(key) {
  return (dispatch) => {
    dispatch({ type: SELECT_PUBLISHED_TYPE, payload: { ispublished: key } });
  };
}

export function selectedSessionID(key) {
  return (dispatch) => {
    dispatch({
      type: SELECTED_SCHEDULE_SESSION_ID,
      payload: { resource: key },
    });
  };
}

export function updatedEventPublished(session, status, callback) {
  let eventid = session.eventid;
  let body = { isautopublish_qa: status, eventid };
  let data = { resource: body };
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function publishedUnpublished(
  session,
  id,
  value,
  selectedSession,
  callback
) {
  let body = { ispublished: value };
  let data = { resource: body };
  var filter = encodeURI(`(eventid=${session.eventid}) AND (qaid=${id})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchLiveQA(session, selectedSession));
        dispatch(fetchUnpublishedLiveQA(session, selectedSession));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function isimportant(session, id, value, selectedSession, callback) {
  let body = { isimportant: value };
  let data = { resource: body };
  var filter = encodeURI(`(eventid=${session.eventid}) AND (qaid=${id})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchLiveQA(session, selectedSession));
        dispatch(fetchUnpublishedLiveQA(session, selectedSession));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function addLiveQA(session, values, selectedSession, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;
  let body = {
    ...values,
    eventid: session.eventid,
    questionedby: session.userid,
  };
  let data = { resource: body };

  return (dispatch) => {
    postRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchLiveQA(session, selectedSession));
        // dispatch(fetchUnpublishedLiveQA(session, selectedSession));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function fetchQAReply(session, qa, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_reply?related=*&filter=(qaid=${qa.qaid})&include_count=true&order=createdon%20ASC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: LIVE_QA_REPLIES, payload: { resource: data } });
        callback({ success: 1, resource: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function replyToLiveQA(session, liveqa, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_reply`;
  let body = [{ ...values }];
  let data = { resource: body };

  return (dispatch) => {
    postRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchQAReply(session, liveqa, callback));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function markBulkImportant(
  session,
  qa,
  pageNumber,
  selectedSession,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;
  let sentData = [];
  qa.map((val, index) => {
    let obj = { qaid: val.qaid, isimportant: 1, eventid: session.eventid };
    sentData.push(obj);
  });

  var body = { resource: sentData, eventid: session.eventid };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({success: 1});
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markBulkUnimportant(
  session,
  qa,
  pageNumber,
  selectedSession,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;
  let sentData = [];
  qa.map((val, index) => {
    let obj = { qaid: val.qaid, isimportant: 0, eventid: session.eventid };
    sentData.push(obj);
  });

  var body = { resource: sentData, eventid: session.eventid };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({success: 1});
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markAllImportant(
  session,
  pageNumber,
  selectedSession,
  callback
) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (sessionid=${selectedSession})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  let sentData = [];
  let obj = { isimportant: 1 };
  sentData.push(obj);

  var body = { resource: sentData };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({success: 1});
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markAllUnimportant(
  session,
  pageNumber,
  selectedSession,
  callback
) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (sessionid=${selectedSession})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  let sentData = [];
  let obj = { isimportant: 0 };
  sentData.push(obj);

  var body = { resource: sentData };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({success: 1});
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markBulkUnpub(
  session,
  qa,
  pageNumber,
  selectedSession,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;
  let sentData = [];
  qa.map((val, index) => {
    let obj = { qaid: val.qaid, ispublished: 0, eventid: session.eventid };
    sentData.push(obj);
  });

  var body = { resource: sentData, eventid: session.eventid };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markAllUnpub(session, pageNumber, selectedSession, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (sessionid=${selectedSession})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  let sentData = [];
  let obj = { ispublished: 0 };
  sentData.push(obj);

  var body = { resource: sentData };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({success: 1});
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markBulkPub(
  session,
  qa,
  pageNumber,
  selectedSession,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;
  let sentData = [];
  qa.map((val, index) => {
    let obj = { qaid: val.qaid, ispublished: 1, eventid: session.eventid };
    sentData.push(obj);
  });

  var body = { resource: sentData, eventid: session.eventid };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markAllPub(session, pageNumber, selectedSession, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (sessionid=${selectedSession})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  let sentData = [];
  let obj = { ispublished: 1 };
  sentData.push(obj);

  var body = { resource: sentData };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchLiveQA(session, selectedSession, pageNumber, callback));
        dispatch(
          fetchUnpublishedLiveQA(session, selectedSession, pageNumber, callback)
        );
        // callback({success: 1});
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function blankSessionRatting() {
  return (dispatch) => {
    dispatch({ type: SCHEDULE_SESSION_RATING, payload: {} });
  };
}

export function fetchRating(session, sessionid, callback) {
  let related =
    "appuser_by_appuserid,session_by_sessionid&appuser_by_appuserid.fields=appuserid,username,firstname,lastname,email&session_by_sessionid.fields=sessionid,title,starttime,endtime,location";
  let filter = encodeURIComponent(
    `(eventid=${session.eventid})AND(sessionid=${sessionid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionratings?include_count=true&related=${related}&filter=(${filter})`;

  return (dispatch) => {
    // dispatch({ type: SCHEDULE_SESSION_RATING, payload: {} });

    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: SCHEDULE_SESSION_RATING,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchAllRating(session, sessionids, callback) {
  // console.log("sessionids :- ", sessionids);
  let related =
    "appuser_by_appuserid,session_by_sessionid&appuser_by_appuserid.fields=appuserid,username,firstname,lastname,email&session_by_sessionid.fields=sessionid,title,starttime,endtime,location";
  let filter = encodeURIComponent(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionratings?include_count=true&related=${related}&filter=(${filter})`;

  return (dispatch) => {
    // dispatch({ type: SCHEDULE_SESSION_RATING, payload: {} });

    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        // console.log("data.resource", data.resource);

        let sessionratings = [];
        data.resource.forEach((o) => {
          let sessionid = o.sessionid;
          let check = _.includes(sessionids, sessionid);
          if (check) {
            sessionratings.push(o);
          }
        });
        // console.log("sessionratings :- ", sessionratings);

        dispatch({
          type: ALL_SCHEDULE_SESSION_RATING,
          payload: { resource: sessionratings, count: sessionratings.length },
        });
        callback({ success: 1, data: sessionratings });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function blankSessionCheckoutForm() {
  return (dispatch) => {
    dispatch({ type: SCHEDULE_SESSION_CHECKOUT_FORM, payload: {} });
  };
}

export function fetchSessionChekoutForm(session, sessionid, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(sessionid=${sessionid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session?fields=sessionid,title,starttime,endtime,location,sessionratingid&related=event_forms_by_sessionratingid&filter=(${filter})`;

  return (dispatch) => {
    // dispatch({ type: SCHEDULE_SESSION_CHECKOUT_FORM, payload: {} });

    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: SCHEDULE_SESSION_CHECKOUT_FORM,
          payload: { data: data.resource.length > 0 ? data.resource[0] : {} },
        });
        callback({
          success: 1,
          data: data.resource.length > 0 ? data.resource[0] : {},
        });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function broadcastQA(show) {
  return (dispatch) => {
    dispatch({ type: BROADCAST_QA, payload: show });
  };
}

export function updateLiveQAList(
  session,
  checkType,
  newArrAvailable,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/custom_script`;
  var body = { newArrAvailable: newArrAvailable, type: "updateLiveQA" };
  return (dispatch) => {
    checkType == "published"
      ? dispatch({
          type: LIVE_QA_LIST,
          payload: { resource: newArrAvailable, count: newArrAvailable.length },
        })
      : dispatch({
          type: UNPUBLISHED_LIVE_QA_LIST,
          payload: { resource: newArrAvailable, count: newArrAvailable.length },
        });

    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openLiveQAExportModal(showModal) {
  return { type: LIVE_QA_EXPORT_MODAL, payload: showModal };
}

export function fetchDownloadLiveQAInfo(session, scheduleSessionid, callback) {
  var url = `${INSTANCE_URL}/api/v2/custom_script`;
  var body = {
    session: session,
    scheduleSessionid: scheduleSessionid,
    type: "downloadliveqainfo",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        // dispatch({type:USER_DOWNLOAD_INFO, payload: {data: data.result, count: data.count}});
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function resetCurrentSessionFormToGlobalForm(
  session,
  sessionid,
  callback
) {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  let values = {
    eventid: session.eventid,
    sessionid: sessionid,
    type: "resetSessionRatingForm",
  };

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success == 1) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
